import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

import UserSidebar from "./UserSidebar";
import CreateCoupon from "../pages/CreateCoupon";
import EditCoupon from "../pages/EditCoupon";
import Constant from "../Components/Utils/Constant";

export default function SubscriptionCoupon() {
  const [showCreatecouponForm, setshowCreatecouponForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showActiveConfirmation, setShowActiveConfirmation] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cupon, setCupon] = useState([]);
  const [loading, setLoading] = useState(true);
  const [couponForAction, setCouponForAction] = useState(null); // To track which coupon to delete
  const tableRef = React.createRef();
  const highlightedId = useSelector(state => state.DataReducer.highlightedId);

  // excel shhet download
  const handleExportToExcel = () => {
    if (tableRef.current) {
      const ws = XLSX.utils.table_to_sheet(tableRef.current);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "tablexls.xlsx");
    }
  };

  const [dropdownStates, setDropdownStates] = useState(
    Array(cupon.length).fill(false)
  );

  // select options toggle
  const toggleDropdown = (index) => {
    const updatedDropdownStates = [...dropdownStates];
    updatedDropdownStates[index] = !updatedDropdownStates[index];
    setDropdownStates(updatedDropdownStates);
  };
  
  // cupon get apii
  const fetchCoupon = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${Constant.BASE_URL}/cupon/getCuponAccess?page=${page}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      const data = await response.json();
      if (data && data.cupon) {
        setCupon(data.cupon);
        if (data.success) {
          setTotalCount(data.totalCount);
          setTotalPages(data.totalPages);
          setDropdownStates(Array(data.cupon.length).fill(false));
        }
      }
    } catch (error) {
      console.error("Error fetching coupon:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoupon(currentPage);
  }, [showCreatecouponForm, currentPage]);

  // paginationnns
  const handlePageClick = async ({ selected }) => {
    const newPageNumber = selected + 1;
    setCurrentPage(newPageNumber);
  };
  
  // pop up form create user
  const handleCreateCouponClick = () => {
    setshowCreatecouponForm(true);
  };

  const handleClosePopup = () => {
    setshowCreatecouponForm(false);
  };

  // Edit form pop up
  const handleEditCoupon = () => {
    setShowEditForm(true);
  };
  const handleCloseEdit = () => {
    setShowEditForm(false);
  };
  
  // State for confirmation popups
  const handleOpenDeleteConfirmation = (coupon) => {
    setCouponForAction(coupon);
    setShowDeleteConfirmation(true);
  };

  const handleCloseConfirmation = () => {
    setShowDeleteConfirmation(false);
    setShowActiveConfirmation(false);
    setCouponForAction(null);
  };

  // delete api
  const handleDelete = async () => {
    if (!couponForAction) return;
    const id = couponForAction._id;
    
    try {
      const response = await axios.delete(`${Constant.BASE_URL}/cupon/delete/${id}`);
      
      if (response.status === 200) {
        toast.success("Coupon deleted successfully");
        fetchCoupon(currentPage); // Refresh the list
      } else {
        toast.error('Failed to delete coupon');
      }
    } catch (error) {
      console.error('Error deleting coupon:', error);
      toast.error('Failed to delete coupon');
    } finally {
        handleCloseConfirmation();
    }
  };

  const handleCopyCouponCode = (couponCode) => {
    navigator.clipboard.writeText(couponCode);
    toast.success("Coupon code copied to clipboard!");
  };

  // Helper function for status as per your requirement
  const getStatus = (coupon) => {
    if (coupon.active === true) {
        return { text: "Expired", className: "text-red-600 font-semibold" };
    }
    // `active` is false
    return { text: "Active", className: "text-green-600 font-semibold" };
  };

  // Helper function to calculate expiry date
  const getExpiryDate = (createdAt, validDays) => {
  if (!createdAt || typeof validDays !== 'number') return "N/A";
  
  const date = new Date(createdAt);
  date.setDate(date.getDate() + validDays);

  // Get day, month, and year
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
  const year = date.getFullYear();

  // Return in DD/MM/YYYY format
  return `${day}/${month}/${year}`;
};

  return (
    <UserSidebar>
      <>
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div className="bg-white h-[78.55vh]" style={{ borderRadius: '0px 0px 11px 11px' }}>
            <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1 ">
                  <div className="flex ">
                    <div
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                      }}
                      className="flex items-center justify-center px-2 ml-3 bg-white rounded-sm cursor-pointer lg:w-fit 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3"
                    >
                      <div className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                        <p>Coupons : {totalCount || cupon?.length}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="tablebodydata overflow-y-auto lg:h-[65vh] xl:h-[64vh] 2xl:h-[66vh] ">
                <table
                  className="table w-full divide-y divide-gray-200 table-hover table-bordered"
                  id="myTable"
                  ref={tableRef}
                >
                  <thead className="bg-gray-100">
                    <tr>
                      <th>Coupon Event </th>
                      <th>Coupon Code</th>
                      <th>Coupon Discount</th>
                      <th>Coupon Status</th>
                      <th>Coupon Expire On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 ">
                    {cupon.map((item, index) => {
                       const statusInfo = getStatus(item);
                       return (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                        style={{ background: highlightedId === item._id ? "yellow" : "none" }}
                      >
                        <td>{item.cuponevent}</td>
                        <td>{item.cuponcode}</td>
                        <td>{item.cupondiscount}%</td>
                        <td className={statusInfo.className}>{statusInfo.text}</td>
                        <td>{getExpiryDate(item.createdAt, item.validdays)}</td>
                        <td className="space-x-2">
                          <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            onClick={() => handleCopyCouponCode(item.cuponcode)}
                          >
                            Copy
                          </button>
                          {/* <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                            onClick={() => handleOpenDeleteConfirmation(item)}
                          >
                            Delete
                          </button> */}
                        </td>
                      </tr>
                    )})}
                  </tbody>
                </table>
              </div>
            </div>
            
            {showCreatecouponForm && (
              <CreateCoupon onClose={handleClosePopup} />
            )}
            
            {showEditForm && <EditCoupon onClosed={handleCloseEdit} />}
          </div>
        </div>
        
        {/* Delete Confirmation Popup */}
        {showDeleteConfirmation && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md 2xl:p-0 w-fit">
              <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3 ">
                  Do you Want to Delete ?
                </div>
                <hr className="p-2 mt-1" />
                <div className="flex items-center justify-center py-5 space-x-4">
                  <button
                    type="button"
                    onClick={handleCloseConfirmation}
                    className=" text bg-white w-20 py-2 flex-shrink-0 shadow-md 2xl:text-3xl 2xl:w-[100px]"
                    style={{
                      boxShadow:
                        "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    No
                  </button>
                  <button
                    onClick={handleDelete}
                    className="text w-20 py-2 flex-shrink-0 text-white 2xl:text-3xl 2xl:w-[100px]"
                    style={{
                      background:
                        "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Pagination code*/}
        <div className="flex lg:px-4">
          <div className="w-full flex bg-white shadow-md backdrop-blur-[5.7px]">
            <div className="w-full flex items-center fixed bottom-0 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl bg-white">
              <div className="flex justify-start w-full xl:px-5 2xl:p-5 p-3">
                <p>
                  Showing {(currentPage - 1) * 10 + 1} to{" "}
                  {Math.min(currentPage * 10, totalCount)} of {totalCount} (Total Coupon)
                  entries
                </p>
              </div>
              <div className="flex justify-end pr-2 text-blue-500 pagination xl:pr-5 p-3">
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"...."}
                  pageCount={totalPages}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination flex items-center space-x-2"}
                  activeClassName={"active bg-blue-500 text-white rounded-full"}
                  pageClassName={"px-3 py-1 rounded-full cursor-pointer"}
                  previousClassName={"px-3 py-1 rounded-full cursor-pointer"}
                  nextClassName={"px-3 py-1 rounded-full cursor-pointer"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </UserSidebar>
  );
}